import api from './api';

export interface ProductEmailConfig {
  productId: number;
  user: string;
  pass: string;
  fromEmail: string;
  fromName: string;
  smtpHost: string;
  smtpPort: number;
  imapHost: string;
  imapPort: number;
  imapSecure: boolean;
}

export interface ProductEmailConfigInput {
  user: string;
  pass: string;
  fromEmail: string;
  fromName?: string;
  smtpHost: string;
  smtpPort: number;
  imapHost?: string;
  imapPort?: number;
  imapSecure?: boolean;
}

export interface LlmConfigMasked {
  hasAnthropicKey: boolean;
  hasOpenaiKey: boolean;
  defaultModel: string;
  fallbackModel: string | null;
  model: string;
  maxTokens: number;
}

export interface LlmConfigInput {
  /** Ausente preserva a chave; '' apaga; valor substitui. */
  anthropicApiKey?: string;
  openaiApiKey?: string;
  defaultModel?: string;
  fallbackModel?: string | null;
  model?: string;
  maxTokens?: number;
}

export type LlmProvider = 'anthropic' | 'openai';

export interface SearchConfigMasked {
  hasBraveKey: boolean;
  hasSerperKey: boolean;
}

export interface SearchConfigInput {
  /** Ausente preserva a chave; '' apaga; valor substitui. */
  braveApiKey?: string;
  serperApiKey?: string;
}

export const settingsService = {
  getConfig: (productId: number): Promise<ProductEmailConfig | null> =>
    api.get('/settings/email', { params: { productId } }).then((r) => r.data),

  saveConfig: (productId: number, data: ProductEmailConfigInput) =>
    api.put('/settings/email', data, { params: { productId } }).then((r) => r.data),

  testSmtpConnection: (productId: number) =>
    api.post('/settings/email/test-smtp', {}, { params: { productId } }).then((r) => r.data),

  testImapConnection: (productId: number) =>
    api.post('/settings/email/test-imap', {}, { params: { productId } }).then((r) => r.data),

  sendTestEmail: (productId: number, email: string) =>
    api.post('/settings/email/send-test', { email }, { params: { productId } }).then((r) => r.data),

  runImapPoll: (opts: { includeRead?: boolean } = {}) =>
    api
      .post('/settings/email/run-bounce-poll', {}, { params: { includeRead: opts.includeRead } })
      .then((r) => r.data),

  getAi: (): Promise<LlmConfigMasked> => api.get('/settings/ai').then((r) => r.data),

  saveAi: (data: LlmConfigInput) => api.put('/settings/ai', data).then((r) => r.data),

  testAi: (provider: LlmProvider) =>
    api.post('/settings/ai/test', { provider }).then((r) => r.data),

  getSearch: (): Promise<SearchConfigMasked> => api.get('/settings/search').then((r) => r.data),

  saveSearch: (data: SearchConfigInput) => api.put('/settings/search', data).then((r) => r.data),
};
